module.exports = __webpack_public_path__ + "static/LG_logo-f289dc674f2a28bc0a7438032d90ef86.png";